import { ValidationErrorBase } from "./validation-error.model";


export class ValidationResultBase {
    
	ok!:boolean;
    errors!:ValidationErrorBase[];


    static from(entity: ValidationResult): ValidationResultBase {

        let current = new ValidationResultBase();
        Object.assign(current, entity)       
        let errors: ValidationErrorBase[] = []
        entity.errors.forEach(r=>{
            errors.push(ValidationErrorBase.from(r))
        })
        current.errors = errors
        return current;
    }
}

export interface ValidationResult extends ValidationResultBase {

}



